import React, { useState } from "react";
import { useIntl } from "react-intl";
import { StyledButton } from "../../Common/Components";
import { useUpdatePool } from "../../entities/api";
import AddAndEditPoolModal from "./AddAndEditPoolModal";

const EditPool = ({ poolCode }) => {
  const [openModal, setOpenModal] = useState(false);
  const { formatMessage } = useIntl();
  const { mutateAsync: updateFn, isPending } = useUpdatePool();

  const handleCloseModal = () => {
    setOpenModal((prev) => !prev);
  };

  const handleSendRequest = async (form) => {
    try {
      const { poolCode, ...data } = await form.validateFields();
      Object.keys(data)?.forEach((key) => {
        if (!data[key]) data[key] = null;
      });
      await updateFn({
        data,
        poolCode,
      });
      handleCloseModal();
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <>
      <StyledButton type="text" size="small" onClick={handleCloseModal}>
        {formatMessage({ id: "manage", defaultMessage: "Manage" })}
      </StyledButton>
      {openModal && (
        <AddAndEditPoolModal
          poolCode={poolCode}
          openModal={openModal}
          handleCloseModal={handleCloseModal}
          handleSendRequest={handleSendRequest}
          okButtonLoading={isPending}
        />
      )}
    </>
  );
};

export default EditPool;
